import { ReactElement } from 'react';
import {
  plPL,
  roRO,
  PickersInputLocaleText
} from '@mui/x-date-pickers/locales';
import { LocalizationProvider as Localization } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import plLocale from 'date-fns/locale/pl';
import enLocale from 'date-fns/locale/en-US';
import roLocale from 'date-fns/locale/ro';
import { Locale } from 'date-fns';

import { country } from 'utils/domainConfig';

const locales: Record<string, Locale> = {
  pl: plLocale,
  ro: roLocale,
  en: enLocale
};

export interface ILocalizationProvider {
  children?: ReactElement | ReactElement[];
}

const localeTextMapping: Record<string, PickersInputLocaleText> = {
  pl: plPL.components.MuiLocalizationProvider.defaultProps.localeText,
  ro: roRO.components.MuiLocalizationProvider.defaultProps.localeText
};

const LocalizationProvider = ({ children }: ILocalizationProvider) => (
  <Localization
    dateAdapter={AdapterDateFns}
    adapterLocale={locales[country]}
    localeText={localeTextMapping[country]}
  >
    {children}
  </Localization>
);

export default LocalizationProvider;
